function debounce<T extends (..._args: any[]) => void>(
  fn: T,
  delay: number
): T {
  let timer: ReturnType<typeof setTimeout>

  return function (this: any, ..._args: any[]) {
    clearTimeout(timer)
    timer = setTimeout(() => fn.apply(this, _args), delay)
  } as T
}
export default debounce
